if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  document.addEventListener("click", (e) => {
    const bssCheckout = document.querySelector(".btn.btn-checkout");
    if (BSS_B2B && bssCheckout && e.target.name === "checkout") {
      e.preventDefault();
      e.stopImmediatePropagation();
      bssCheckout.click();
    }
  });
}
